<template>
<div>
  <div class="container-full bg-map" :class="{'zoom-active': zoomStatus}">
    <div class="minimap-container">
      <svg width="100px" height="100px" id="minimap"></svg>
    </div>


    <div class="tools-block">
      <h3 class="text-left">Actividad pesquera industrial en las tres reservas nacionales del Perú</h3>
      <div></div>
    </div>

    <div class="tools-timeline">

      <div class="btn-group d-none" role="group" aria-label="Años">
        
        <button :class="{'active': i == anioSelected}" type="button" class="btn btn-timeline" @click="showYear(i)" v-for="i in aniosDisponibles" :key="i">
          {{ i }}
        </button>
        <div>
          <div class="progress-play"></div>
        </div>
      </div>
      
      

    </div>

    <div class="narrative-map">
      Los industriales ingresaron masivamente a Paracas entre el 2017 y el 2020 —dicen los especialistas— debido a que buscaban marcar un precedente porque en esos años estaba en discusión la creación de la Dorsal de Nasca.
    </div>

    <div class="explora-datos-block text-left mb-5">
      <div class="especies-block">
        <div class="p-3">
          <h3>Explora los datos de <strong>actividad pesquera</strong> de por área protegida.</h3>
        </div>
        <div class="accordion" id="accordionReservas">

          <div v-for="(card, e) in speciesColors" :key="`item_${card.id}`">
            <div class="" :id="`heading_${card.id}`">
              <h2 class="mb-0">
                <button @click="zoomToReserve(e)" class="btn-reserva btn-block text-left" type="button">
                  {{ card.especie }} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
                    <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
                    <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
                  </svg>
                </button>
              </h2>
            </div>
        
            <div :id="`collapse_${card.id}`" class="collapse" :class="{'show': reservaSelected.id == card.id}" :aria-labelledby="`heading_${card.id}`" data-parent="#accordionReservas">
              <div class="card-body">
  
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li :key="`anio-bar-${(anio.anio)}`" v-for="(anio) in aniosBars(card.data)" class="nav-item" role="presentation">
                    <button @click="showYear(anio.anio)" :class="{'active': anio.anio == anioSelected}" class="nav-link" :id="`pills-${anio.id}-${(anio.anio)}-tab`">{{ anio.anio }}</button>
                  </li>
                </ul>

                <div class="tab-content" id="pills-tabContent">
                  <div :key="`anio-content-${(anio.anio)}`" v-for="(anio) in aniosBars(card.data)" class="tab-pane fade" :class="{'active show': anio.anio == anioSelected}" :id="`pills-${anio.id}-${(anio.anio)}`" role="tabpanel" :aria-labelledby="`pills-${anio.id}-${(anio.anio)}-tab`">
                    <h5>Se registro actividad de {{ anio.count }} embaraciones en el {{ anio.anio }}</h5>
                    <ul class="bar-top">
                      <li type="button" class="" @click="monthSelected=i.ix" v-for="i in anio.months" :key="`bar_${anio.anio}_${i.ix}`">
                        <div class="w-bar">
                          <label :style="`bottom: ${barHeightTotal(i.count, anio.count)}px;`">{{ i.count }}</label>
                          <div class="bar" :style="`height: ${barHeightTotal(i.count, anio.count)}px;`">
                          </div>
                        </div>
                        <span>* {{ i.month }}</span>
                      </li>
                    </ul>

                    <div class="disclaimer-map">*Los meses donde no hay registro es porque no hubo temporada de pesca o no hay reporte de los GPS.</div>
                  </div>

                  
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="map-float-container">
      <svg id="map" class="map-svg">
        <g class="coast"></g>
        <g class="reservas"></g>
        <g class="nasca boats"></g>
        <g class="grau boats"></g>
        <g class="paracas boats"></g>
      </svg>
      <div class="active-results">Mostrando <span class="lbl-emb">{{ totalBoats }} embaraciones</span> registradas en el {{ anioSelected }}</div>
    </div>
   
    <div class="fuente-interactive">Fuentes: Produce, Oceana, Artisonal y Global Fishing Watch | El Foco</div>

  </div>
</div>
</template>

<style lang="scss">
  .active-results {
    position: absolute;
    top: 45vh;
    right: 15px;
    color: #dbdbdb;
    width: 120px;
    text-align: left;
    font-size: 14px;
    pointer-events: none;

    @media screen and (max-width: 860px) {
      top: 35vh;
      left: 15px;
      width: 120px;
      font-size: 14px;
    }
  }

  .card-body {
    padding: 10px;
  }

  .bar-top li {
    position: relative;
    display: inline-block;
  }
 
  .bar-top li .w-bar {
    height: 120px;
    width: 30px;
    margin: 0 5px;
    position: relative;
    display: flex;
    align-items: flex-end;
  }
  
  .bar-top li .w-bar .bar{
    background-color: #b32400ce;
    width: 90%;
    margin: 0 auto;
  }
  
  .bar-top li span {
    position: absolute;
    bottom: -15px;
    font-size: 10px;
    display: block;
    width: 100%;
    text-align: center;
  }
  
  
  .bar-top li label {
    position: absolute;
    font-size: 10px;
    margin: 0;
    display: block;
    width: 100%;
    text-align: center;
  }

  .fuente-interactive {
    font-size: 17px;
    text-align: right;
    color: #fff;
    position: absolute;
    right: 15px;
    bottom: 15px;
  }
  #map {
    position: relative;
    width: 100%;
    left: 0vw;

    text {
      fill: #e3e3e3;
      pointer-events: none;
      font-size: 16px;
      text-shadow: 1px 1px 1px #000;
    }
  }

  .nav-link {
    color: #fff;
    background-color: #5a5a5a !important;
    border-radius: 0 !important;
    border-right: dashed 1px #000 !important;
    padding: 5px 10px;
  }
  
  .nav-link.active {
    color: #000;
    background-color: #b32400ce !important;
  }

  .zoom-active {
    #map {
      position: relative;
      width: 100%;
      left: 0vw;

      text {
        fill: #e3e3e3;
        pointer-events: none;
        display: none;
      }
    }
  }

  .btn-reserva {
    background: #c2fff7;
    font-size: 18px;
    padding: 10px;
    color: #000;
    border: none;
    border-bottom: dashed 1px #000;
  }

  .btn-timeline {
    height: 10px;
    color: #fff;
  }

  circle.boat-circle {
    cursor: pointer;
    fill: #b32400ce;
    stroke: #f28705;
    stroke-width: 0.05;

    &:hover {
      fill: #000
    }

    &.pass {
      fill: rgba(255, 255, 255, 0.086);
      stroke: rgba(255, 255, 255, 0.16);
      pointer-events: none;
    }
  }
  
  span.lbl-emb {
    background-color: #b32400;
    color: #fff;
  }
  .explora-datos-block {
    position: absolute;
    bottom: 0;
    width: 100%;
    max-width: 420px;
    left: 0px;
    background-color: #d0d0d0;
    z-index: 999;
    transition: bottom .25s ease-in-out;

    h3 {
      font-size: 21px;
      font-family: 'Fira Sans';

      strong {
        color: #b32400;
      }
    }

    h5 {
      font-size: 13px;
      font-weight: 600;
    }
  }
  
  .explora-datos-block.inactive {
    position: absolute;
    bottom: -100vh;
  }

  .zona-pesca {
    stroke-width: 1;
    fill: rgba(0, 255, 221, 0.826);
    stroke: rgba(255, 95, 15, 0.087);
    stroke-dasharray: 0 5 0;
    cursor: pointer;

    &:hover {
      fill: yellow;
    }
  }

  .zoom-active {
    .zona-pesca {
      &:hover {
        fill: rgba(0, 255, 221, 0.826);
      }
    }
  }

  .map-svg {
    width: 100vw;
    height: 100vh;
  }

  .departamento-mapa {
    fill: rgba(255, 255, 255, 0.236) !important;
    font-size: 7px !important;
  }

  .slider-selection {
    background-color: #87c7ff;
    background-image: none;
  }

  .slider-handle {
    position: absolute;
    top: 0;
    width: 20px;
    height: 20px;
    background-color: #87c7ff;
    background-image: linear-gradient(to bottom, #87c7ff 0%, #2e6da4 100%);
    background-repeat: repeat-x;
    filter: none;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .2), 0 1px 2px rgba(0, 0, 0, .05);
    border: 0px solid transparent;
  }

  .tools-block {
    max-width: 420px;
    position: absolute;
    padding: 15px;
    z-index: 99;
    top: 15px;
    left: 15px;
    color: #fff;
    text-align: left;
    line-height: 1.7em;
    

    h3 {
      font-weight: 700;
      font-family: 'Fira Sans';
      text-shadow: 1px 1px 1px #000;
    }

    &.inactive {
      left: -500px;
    }

    input {
      pointer-events: all;
    }
    
    button {
      pointer-events: all;
    }

    .especies-block {
      margin-top: 55px;
      text-align: left;
      color: #F28705;
      label {
        color: #fff;
      }

    }
  }
  
  .map-player {
    position: absolute;
    width: 100%;
    padding: 15px;
    z-index: 99;
    left: 0;
    top: -100px;
    transition: top .25s ease-in-out;

    &.active {
      top: 0;
    }

    .slider.slider-horizontal {
      width: 90%;
      min-width: 320px;
    }
  }

  .tools-timeline {
    position: absolute;
    padding: 15px;
    z-index: 99;
    bottom: 0;
    right: 0;

    input {
      pointer-events: all;
    }
    
    button {
      pointer-events: all;
      background: #fff;
      color: #000;
      font-weight: 900;
    }

    .especies-block {
      margin-top: 55px;
      text-align: left;
    }
  }

  .disclaimer-map {
    font-size: 15px;
    padding: 10px;
  }

  .map-path {
    fill: #333;
    stroke: rgb(108, 108, 108);
    stroke-width: 0.5;
  }

  .bg-map {
    margin: 0 auto;
    width: 100%;
    max-width: 1120px;
    position: relative;
    background-color: #071320;
    overflow: hidden;
  }

  .minimap-container {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
    background: rgb(176, 210, 240);
    border-radius: 50%;
  }

  .map-float-container {
    position: relative;
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    height: 100vh;
  }

  @media screen and (max-width: 860px) {
    .map-float-container {
      height: 110vh;
    }
  }

  .narrative-map {
    position: absolute;
    width: 100%;
    max-width: 420px;
    background: #000000;
    top: 125px;
    color: #fff;
    padding: 15px;
    text-align: left;
    left: -500px;
    box-shadow: 1px 1px 5px 3px #00000033;
    font-size: 21px;
    transition: left .25s ease-in-out;

    @media screen and (max-width: 860px) {
      top: 75vh;
    }

    &.active {
      left: 15px;
    }
  }

  .tooltip {
    color: #000;
  }
</style>

<script>

import * as d3 from 'd3'
import { filter,groupBy, map, orderBy, uniq, kebabCase } from 'lodash'

export default {
  name: 'MapaPesca',
  data() {
    return {
      totalBoats: 0,
      transform: {},
      selectSlider: 0,
      resumenMode: false,
      zoomLevel: 8,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      tooltip: null,
      width: 720,
      height: 0,
      initCenterL: [-16.5, -85],
      initCenter: [-79.7390546,-14.680146],
      aniosDisponibles: [],
      mesesDisponibles: [],
      selectEmbarcacion: `paracas`,
      selectPuerto: `paracas`,
      checkEspecies: [],
      anioSelected: `2024`,
      monthSelected: 0,
      circles: {},
      playAllIntervalId: null,
      reservaSelected: {},
      zoomStatus: false,
      colors: {
        "nasca": "#1f77b4",
        "grau": "#ff7f0e",
        "paracas":"#2ca02c"
      },
      narrativa: {
        '2017': {
          text: `Los industriales ingresaron masivamente a Paracas entre el 2017 y el 2020 —dicen los especialistas— debido a que buscaban marcar un precedente porque en esos años estaba en discusión la creación de la Dorsal de Nasca.`,
          center: [-77.2715518785092, -14.6029086983948995],
          scale: 6
        },
        '2018': {
          text: `Paracas es reserva desde 1975 y tiene una extensión de 335 km2, de los cuales el 35% es tierra firme y el 65%, aguas oceánicas. Allí está prohibida la pesca industrial de cualquier tipo.`,
          center: [-77.4915518785092, -13.5029086983948995],
          scale: 5
        },
        '2019': {
          text: `En el 2019, cuando se estaba formulando el plan maestro de creación de la Dorsal de Nasca, las grandes pesqueras peruanas, organizadas gremialmente en la Sociedad Nacional de Pesquería (SNP), argumentaron que tenían más de una década pescando en la zona y, por lo tanto, “derechos adquiridos”.`,
          center: [-82.28918165666728, -13.265106097156545],
          scale: 1
        },
        '2021': {
          text: `Luego de una intensa lucha de organizaciones sociales y ambientales por fortalecer la defensa de los ecosistemas marinos, el Estado peruano constituyó la reserva de Dorsal de Nasca en junio de 2021. Se trata de la mayor área natural protegida del país, con 62.392 kilómetros`,
          center: [-80.23530634264387,-13.87517954738529],
          scale: 2
        },
        '2022': {
          text: `Desde que se creó la Reserva Dorsal de Nasca, el 5 de junio del 2021, ha tenido ingresos de embarcaciones industriales en hasta 796 oportunidades, según registros oficiales.`,
          center: [-80.23530634264387,-13.87517954738529],
          scale: 2
        },
        '2023': {
          text: `En diciembre de 2023, Oceana presentó una demanda constitucional para que se declare ilegal la pesca industrial en la Dorsal de Nasca. La ONG busca que se respete un derecho clave en toda área natural protegida. La audiencia judicial donde se analizará la demanda se ha programado para marzo del próximo año.`,
          center: [-80.23530634264387,-13.87517954738529],
          scale: 2
        },
        '2024': {
          text: `Desde el 24 de abril de este año existe la reserva Mar Tropical de Grau, de 115.000 hectáreas. Está compuesta por cuatro rectángulos separados: Isla Foca, Cabo Blanco-El Ñuro, Arrecifes de Punta Sal y Banco de Máncora.`,
          center: [-82.28918165666728, -13.265106097156545],
          scale: 1
        }
      }
    }
  },
  watch: {
    monthSelected(v) {
      this.svg.selectAll("circle").classed('pass', true)
      this.svg.selectAll(`circle.boat-month-${v}`).classed('pass', false)
    },
    anioSelected(v) {
      this.totalBoats = 0
      this.svg.selectAll("circle").remove()
      this.mesesDisponibles = []
      this.selectSlider = this.aniosDisponibles.indexOf(v)
      this.checkEspecies.forEach(element => {
        this.renderBoats(this.speciesColors[element], element)
      })
    },
    checkEspecies(values) {
      this.totalBoats = 0
      this.svg.selectAll("circle").remove()
      this.aniosDisponibles = []
      values.forEach(element => {
        this.renderBoats(this.speciesColors[element], element)
      })
    }
  },
  computed: {
    nascaData() {
      return require('@/data/nasca.json')
    },
    speciesColors() {
      return {
        "nasca": {
          "id": "nasca-data",
          "especie": "Dorsal de Nasca",
          "color": "#ff6500fa",
          "data": this.nascaData,
          "center": [-78.26024556845394, -15.997795797198995],
          "min": 2022,
          "scale": 3,
          "r": 3
        },
        "paracas": {
          "id": "paracas-data",
          "especie": "Reserva Nacional de Paracas",
          "color":  "#ff6500fa",
          "data": require('@/data/paracas.json'),
          "center": [-76.5715518785092, -14.1029086983948995],
          "min": 2017,
          "scale": 15,
          "r": 15
        },
        "grau": {
          "id": "grau-data",
          "especie": "Reserva de Grau",
          "color": "#ff7f0e",
          "data": require('@/data/grau.json'),
          "center": [-81.23753331842, -3.47048404291116],
          "min": 2024,
          "scale": 45,
          "r": 45
        },
      }
    },
    boats() {
      return require('@/data/embarcaciones.json')
    },
    list_puertos() {
      return uniq(map(this.boats, 'Punto de Zarpe'))
    },
    path() {
      return d3.geoPath().projection(this.projection)
    },
    minipath() {
      return d3.geoPath().projection(this.miniprojection)
    },
    svg() {
      // Set up the SVG
      return d3.select("#map");
    },
    miniprojection() {
      return d3.geoOrthographic()
          .center([0,0]) 
          .scale(50)
          .clipAngle(90)
          .translate([50, 50]) 
          .rotate([70,-10, 9]) 
    },
    projection() {
      let scale = 1700
      let center = [this.width / 2.3, window.innerHeight / 1.6]
      if(this.width > 720) {
        scale = 2500
        center = [this.width / 1.7, window.innerHeight / 1.4]
      }

      return d3.geoMercator()
        .center(this.initCenter)
        .translate(center)
        .scale(scale)
    },
    zoom() {
      return d3.zoom()
        .scaleExtent([1, 16])  // Define the zoom scale limits
        .on("zoom", (event) => {
            this.svg.selectAll('g.coast')
              .attr("transform", event.transform)
            
              this.svg.selectAll('g.reservas')
              .attr("transform", event.transform)
              
              this.svg.selectAll('g.boats')
              .attr("transform", event.transform)
        })
    }
  },
  methods: {
    kebabCase,
    barHeightTotal(i, d) {
      const scale = d3.scaleLinear().domain([1, d]).range([1,100])
      return scale(i)
    },
    getMonthNameInSpanish(monthNumber) {
      const monthsInSpanish = [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
      ];
      return monthsInSpanish[monthNumber - 1] || "Mes inválido";
    },
    aniosBars(data) {
      return map(groupBy(data, `anio`), (row, anio) => {
        return {
          anio: anio,
          count: row.length,
          row: row,
          months: map(groupBy(row, 'month'), (d, month)=> {
            return {
              month: this.getMonthNameInSpanish(month),
              ix: month,
              count: d.length
            }
          })
        }
      })
    },
    createTooltip() {
      this.tooltip = d3.select("#tooltipMapaPesca")
    },
    renderBoats(boats, reserva) {
      const data_filtered = filter(boats.data, d => {
        if(d[`anio`] == this.anioSelected) {
          return d
        }
      })

      // Sort boats by date
      data_filtered.sort((a, b) => b["toneladas_pesca"] - a["toneladas_pesca"])
      data_filtered.sort((a, b) => b["anio"] - a["anio"])

      this.aniosDisponibles = orderBy(uniq(this.aniosDisponibles.concat(uniq(map(boats.data, 'anio')))))
      this.mesesDisponibles = orderBy(uniq(this.mesesDisponibles.concat(uniq(map(data_filtered, 'month')))))

      if(data_filtered.length == 0) return false

      this.circles = this.svg.select(`g.${reserva}`)
        .selectAll("circle")
        .data(data_filtered)
        .enter()
        .append("circle")
        .attr("cx", d =>{
          this.totalBoats += 1
          return this.projection([+d.longitud, +d.latitud])[0]
        })
        .attr("cy", d => {
          return this.projection([+d.longitud, +d.latitud])[1]
        })
        .attr("r",0)
        .style("opacity", 0)
        .attr("class", (d) => `boat-circle boat-${d.anio} boat-month-${d.month}`)
        .on("mouseover", (event, d) => {
          this.tooltip.transition()
            .duration(200)
            .style("opacity", .9)
            .style("visibility", 'visible')
            .style("display", 'block')
            

          let data = `
              <div>Embaración</div>
              <h6><strong>${d.embarcacion}</strong></h6>
              <div>Matrícula:</div>
              <div><strong>${d.matricula}</strong></div>
              <div>Fecha de actividad:</div>
              <div><strong>${d.fecha_inicio}</strong></div>
              <div>Reserva protegida:</div>
              <div><strong>${d.reserva}</strong></div>
            `
          this.tooltip.html(data)
            .style("left", (event.pageX) + "px")
            .style("top", (event.pageY - 28) + "px")
        })
        .on("mouseout", () => {
            this.tooltip.transition()
            .duration(500)
            .style("visibility", 'hidden')
            .style("opacity", 0)
        })

        let r = (this.reservaSelected.r) ? 10 / this.reservaSelected.r : 10
        
        if(this.zoomStatus) {
          r = (boats.r) ? 10 / boats.r : 10
        } else {
          r = 5
        }

        let rD = r

        this.circles
          .attr("r", 0)  // Grow to radius 10
          .transition()
          .duration(1000)
          .attr("r", rD)
          .style("opacity", 1)
          


    },
    playAnimation(year, month) {
      console.log(year, month)
    },
    showYear(y) {
      if (y === 'play_all') {
        let yearIndex = 0;
        let monthIndex = 0;
        this.resumenMode = true
        
        this.svg.selectAll(`circle`).remove();
        
        d3.select(`.explora-datos-block`).classed('inactive', true)
        d3.select(`.tools-block`).classed('inactive', true)
        d3.select(`.map-player`).classed('active', true)

        clearInterval(this.playAllIntervalId)
        
        const intervalId = setInterval(() => {
          if (yearIndex < this.aniosDisponibles.length) {
            const currentYear = this.aniosDisponibles[yearIndex];
            const currentMonth = this.mesesDisponibles[monthIndex];
            
            // Update map only when the year changes
            if (this.anioSelected !== currentYear) {
              this.updateMap(currentYear);
            }
            
            this.anioSelected = currentYear;
            this.monthSelected = currentMonth;
            monthIndex++;

            if (monthIndex >= this.mesesDisponibles.length) {
              monthIndex = 0;
              yearIndex++;
            }
          } else {
            clearInterval(intervalId)
            this.resumenMode = false
            d3.select(".narrative-map").classed('active', false)
            d3.select(`.explora-datos-block`).classed('inactive', false)
            d3.select(`.tools-block`).classed('inactive', false)
            d3.select(`.map-player`).classed('active', false)

          }
        }, 1300)

        // Store the interval ID if you need to stop it later
        this.playAllIntervalId = intervalId;
      } else {
        // If a specific year is selected, clear any running interval
        if (this.playAllIntervalId) {
          this.resumenMode = false
          clearInterval(this.playAllIntervalId)
          d3.select(".narrative-map").classed('active', false)
          d3.select(`.explora-datos-block`).classed('inactive', false)
          d3.select(`.tools-block`).classed('inactive', false)
          d3.select(`.map-player`).classed('active', false)
        }
        this.anioSelected = y;
        this.monthSelected = '1';
      }
    },
    zoomToReserve(reserve) {
      this.totalBoats = 0
      const data = this.speciesColors[reserve]
      if (!data) return

      this.reservaSelected = data 

      let [x, y] = [this.width / 3.5, window.innerHeight / 4.5]
      if(this.width > 720) {
        [x, y] = [this.width / 2, window.innerHeight / 2.5]
      }
      

      this.svg
        .transition()
        .duration(500) // 1 second transition
        .call(this.zoom.transform, d3.zoomIdentity
          .translate(x,y)
          .scale(data.scale)
          .translate(-this.projection(data.center)[0], -this.projection(data.center)[1])
        )
        .on("start", () => {
          this.zoomStatus = true
          this.svg.selectAll("circle").remove()
          d3.select(`.tools-block`).classed('inactive', true)
        })
        .on("end", () => {
          this.checkEspecies = [reserve]
          this.anioSelected = this.reservaSelected.min
        })
    },
    updateMap(year) {
      this.zoomStatus = true
      const data = this.narrativa[year]
      if (!data) return
      
      let [x, y] = [this.width / 2, window.innerHeight / 1.8]
      if(this.width > 720) {
        [x, y] = [this.width / 2, window.innerHeight / 2.5]
      }

      this.svg
        .transition()
        .duration(500) // 1 second transition
        .call(this.zoom.transform, d3.zoomIdentity
          .translate(x,y)
          .scale(data.scale)
          .translate(-this.projection(data.center)[0], -this.projection(data.center)[1])
        )

      if(this.resumenMode) {
        // Update text
        d3.select(".narrative-map").classed('active', false)
        
        setTimeout(() => {
          d3.select(".narrative-map").text(data.text)
          d3.select(".narrative-map").classed('active', true)
        }, 300)
      }
    },
    renderMap() {

      this.height = window.innerHeight

      const world_json = require(`@/data/world.json`)

      const peru_geojson = require(`@/data/peru.json`)

      const peru_departamentos = require(`@/data/departamentos_peru.json`)

      this.reservaSelected = `all`

      d3.select("#minimap")
        .selectAll("path")
        .data(world_json.features)
        .enter()
        .append("path")
        .attr("d", this.minipath)
        .attr("class", "map-path")

      this.svg.select("g.reservas")
        .selectAll("path")
        .data(peru_geojson.features)
        .enter()
        .append("path")
        .attr("d", this.path)
        .attr("class", "map-path")
     
      this.svg.select("g.reservas")
        .selectAll("text")
        .data(peru_departamentos.features)
        .enter()
        .append("text")
        .attr("x", d => this.path.centroid(d)[0] + 4)
        .attr("y", d => this.path.centroid(d)[1])
        .attr("text-anchor", "middle")
        .attr("dy", ".35em")
        .text(d => d.properties.NOMBDEP)
        .attr("class", "departamento-mapa")
        .call(this.zoom)

      // Create a path generator
      this.renderDorsal()
    },
    renderDorsal() {

      const dorsal_data = require(`@/data/gazetteer_polygon.json`)
      const paracas_data = require(`@/data/paracas_marine.json`)
      const grau_data = require(`@/data/grau_marine.json`)

      //this.projection.scale(6000)
      // Draw Peru's coastline
      this.svg.select("g.reservas")
        .append("path")
        .data(dorsal_data.features)
        .attr("d", this.path)
        .on("click", () => {
          this.zoomToReserve(`nasca`)
        })
        .attr("class", "zona-pesca nasca")
        .on("mouseover", (event) => {

          if(this.zoomStatus) return false

          this.tooltip.transition()
            .duration(200)
            .style("opacity", .9)
            .style("visibility", 'visible')
            .style("display", 'block')
            
          let data = `<h6>Dorsal de Nazca</h6>`
              
          data+=``


          this.tooltip.html(data)
            .style("left", (event.pageX) + "px")
            .style("top", (event.pageY - 28) + "px")
          })
          .on("mouseout", () => {
            this.tooltip.transition()
            .duration(500)
            .style("visibility", 'hidden')
            .style("opacity", 0)
          })
        
      
      this.svg.select("g.reservas").append("text")
        .data(dorsal_data.features)
        .attr("x", d => this.path.centroid(d)[0])
        .attr("y", d => this.path.centroid(d)[1] - 15)
        .attr("text-anchor", "middle")
        .attr("dy", ".35em")
        .text(`Dorsal de Nasca`)
        .attr("class", "zona-pesca-label")
      
        
        this.svg.select("g.reservas")
        .append("path")
        .data(paracas_data.features)
        .attr("d", this.path)
        .attr("class", "zona-pesca paracas")
        .on("click", () => {
          this.zoomToReserve(`paracas`)
        })
        .on("mouseover", (event, d) => {

          if(this.zoomStatus) return false

          this.tooltip.transition()
            .duration(200)
            .style("opacity", .9)
            .style("visibility", 'visible')
            .style("display", 'block')
            
          let data = `<h6>Dorsal de Nazca</h6>`
              
          data+=`Total de embarcaciones desde  ${d}`


          this.tooltip.html(data)
            .style("left", (event.pageX) + "px")
            .style("top", (event.pageY - 28) + "px")
          })
          .on("mouseout", () => {
            this.tooltip.transition()
            .duration(500)
            .style("visibility", 'hidden')
            .style("opacity", 0)
          })
        
      this.svg.select("g.reservas").append("text")
        .data(paracas_data.features)
        .attr("x", d => this.path.centroid(d)[0])
        .attr("y", d => this.path.centroid(d)[1] - 15)
        .attr("text-anchor", "middle")
        .attr("dy", ".30em")
        .text(`Reserva de Paracas`)
        .attr("class", "zona-pesca-label")

      this.svg.select("g.reservas")
          .selectAll("path.grau")
          .data(grau_data.features)
          .enter()
          .append("path")
          .attr("d", this.path)
          .attr("class", "zona-pesca grau")
          .on("click", () => {
            this.zoomToReserve(`grau`)
          })
          .on("mouseover", (event, d) => {

            if(this.zoomStatus) return false
            
            this.tooltip.transition()
              .duration(200)
              .style("opacity", .9)
              .style("visibility", 'visible')
              .style("display", 'block')

            let data = `<h6>${d.properties.NAME}</h6>`
                
            data+=`Total de embarcaciones desde ${d}`

            console.log(d)

            this.tooltip.html(data)
              .style("left", (event.pageX) + "px")
              .style("top", (event.pageY - 28) + "px")
            })
            .on("mouseout", () => {
              this.tooltip.transition()
              .duration(500)
              .style("visibility", 'hidden')
              .style("opacity", 0)
            })

      this.svg.select("g.reservas").append("text")
        .data(grau_data.features)
        .attr("x", d => this.path.centroid(d)[0])
        .attr("y", d => this.path.centroid(d)[1] - 15)
        .attr("text-anchor", "middle")
        .attr("dy", ".30em")
        .text(`Reserva de Grau`)
        .attr("class", "zona-pesca-label")

    }
  },
  mounted() {
    this.width = document.querySelector(`.map-float-container`).offsetWidth
    //this.height = document.querySelector(`.map-float-container`).offsetHeight

    this.checkEspecies.push('paracas')
    this.checkEspecies.push('nasca')
    this.checkEspecies.push('grau')
    
    this.renderMap()
    this.createTooltip()

  }
}


</script>